import { Box, Autocomplete, TextField, Typography } from '@mui/material';
import { layout, inputSx, badgeStyle, WEBSITE_PUBLICATION_STATE } from '../styles/ds';

/**
 * N ordered slots, each picking one website listing; a listing can't be picked
 * twice. `value` is an array of ids (null = empty slot). `warnings` maps an id
 * to a short text shown under its slot (e.g. "not public").
 */
const ListingSlots = ({ count = 4, value, onChange, options, disabled, warnings = {}, labelPrefix = 'מקום' }) => {
  const byId = new Map(options.map(o => [o.id, o]));
  const chosen = new Set(value.filter(Boolean));
  return (
    <Box sx={layout.formGrid}>
      {Array.from({ length: count }, (_, i) => {
        const id = value[i] ?? null;
        const current = id ? byId.get(id) ?? { id, name_en: id, slug: '' } : null;
        return (
          <Box key={i}>
            <Autocomplete size="small" disabled={disabled}
              options={options.filter(o => !chosen.has(o.id) || o.id === id)}
              value={current}
              getOptionLabel={o => `${o.name_en}${o.slug ? ` · ${o.slug}` : ''}`}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              renderOption={(props, o) => (
                <li {...props} key={o.id}>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
                    <span dir="ltr" style={{ flex: 1 }}>{o.name_en}</span>
                    {o.publication_state && (
                      <span style={badgeStyle(WEBSITE_PUBLICATION_STATE, o.publication_state)}>
                        {WEBSITE_PUBLICATION_STATE[o.publication_state]?.label}
                      </span>
                    )}
                  </Box>
                </li>
              )}
              onChange={(e, o) => {
                const next = Array.from({ length: count }, (_, j) => value[j] ?? null);
                next[i] = o ? o.id : null;
                onChange(next);
              }}
              renderInput={params => <TextField {...params} label={`${labelPrefix} ${i + 1}`} sx={inputSx} />} />
            {id && warnings[id] && (
              <Typography fontSize={12} color="warning.dark" mt={0.5}>{warnings[id]}</Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};
export default ListingSlots;
